import React from "react";
import { FormattedMessage } from "react-intl";
import { Grid } from "@material-ui/core";
import View from "components/utils/View";
import { Link } from "react-router-dom";
import { SrButton, Typography } from "../../common";

const NotFound = () => (
  <View translateTitleKey="notFound.title">
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="space-beetwen"
      spacing={8}
    >
      <Grid item xs={12}>
        <Typography variant="h2">
          <FormattedMessage id="notFound.title" />
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <SrButton component={Link} to={"/"} color="primary" variant="contained">
          <FormattedMessage id="notFound.homeButton" />
        </SrButton>
      </Grid>
    </Grid>
  </View>
);

export default NotFound;
